import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VLabel, [_vm._v(_vm._s(_vm.$t('Dashboards.components.actionsEditor.title')))]), _c(VForm, {
    ref: "addForm",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.addNewAction.apply(null, arguments);
      }
    },
    model: {
      value: _vm.addFormValid,
      callback: function ($$v) {
        _vm.addFormValid = $$v;
      },
      expression: "addFormValid"
    }
  }, [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "label": _vm.$t('Dashboards.components.actionsEditor.inputs.label.label'),
      "required": "",
      "rules": [_vm.rules.required],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.newActionLabel,
      callback: function ($$v) {
        _vm.newActionLabel = $$v;
      },
      expression: "newActionLabel"
    }
  })], 1), _c(VCol, [_c(VSelect, {
    attrs: {
      "items": _vm.actionDefinitions,
      "item-value": "type",
      "item-text": "text",
      "label": _vm.$t('Dashboards.components.actionsEditor.inputs.action.label'),
      "required": "",
      "rules": [_vm.rules.required],
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.newActionAction,
      callback: function ($$v) {
        _vm.newActionAction = $$v;
      },
      expression: "newActionAction"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_c('core-button', {
    attrs: {
      "icon": "",
      "color": _vm.color,
      "type": "submit"
    }
  }, [_c(VIcon, [_vm._v("fal fa-plus")])], 1)], 1)], 1)], 1), _vm._l(_vm.definedActions, function (action, index) {
    return _c(VRow, {
      key: `action-${index}`
    }, [_c(VCol, [_c(VTextField, {
      attrs: {
        "value": action.label,
        "label": _vm.$t('Dashboards.components.actionsEditor.inputs.label.label'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled
      },
      on: {
        "input": function ($event) {
          return _vm.updateAction(index, 'label', $event);
        }
      }
    })], 1), _c(VCol, [_c(VSelect, {
      attrs: {
        "value": action.action,
        "items": _vm.actionDefinitions,
        "item-value": "type",
        "item-text": "text",
        "label": _vm.$t('Dashboards.components.actionsEditor.inputs.action.label'),
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled
      },
      on: {
        "input": function ($event) {
          return _vm.updateAction(index, 'action', $event);
        }
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "auto"
      }
    }, [_c('core-button', {
      attrs: {
        "color": _vm.color,
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.openActionParameters(index);
        }
      }
    }, [_c(VIcon, [_vm._v("fal fa-function")])], 1), _c('core-button', {
      attrs: {
        "color": "error",
        "icon": ""
      },
      on: {
        "click": function ($event) {
          return _vm.removeAction(index);
        }
      }
    }, [_c(VIcon, [_vm._v("fal fa-trash")])], 1)], 1)], 1);
  }), _c('action-parameters-edit-dialog', {
    attrs: {
      "action": _vm.openedAction,
      "parameter-definitions": _vm.openedActionParameterDefinitions,
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "update:parameters": _vm.onParametersUpdated
    },
    model: {
      value: _vm.showActionParametersDialog,
      callback: function ($$v) {
        _vm.showActionParametersDialog = $$v;
      },
      expression: "showActionParametersDialog"
    }
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };